import classnames from 'classnames'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import _ from 'lodash'
import { useEffect, useMemo, useState } from 'react'
import { getCommunityCategories } from '../../../actions/programCategoryActions'
import { getProgramsFilterOptions } from '../../../actions/programActions'
import LeaderboardWrapper from '../../common/leaderboard/LeaderboardWrapper'
import FiltersButtonDropdown, { FIXED_DATE_RANGES_FUNCTIONS } from './FiltersButtonDropdown'

import styles from './CoachDashboardOp36.module.scss'

const DEFAULT_FILTERS = {
  ...FIXED_DATE_RANGES_FUNCTIONS['30days'].valueFunc(),
  categoryOption: null,
  programOption: null,
}

const CoachDashboardCommunityLeaderboard = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [filters, setFilters] = useState(DEFAULT_FILTERS)

  const requestFilters = useMemo(() => ({
    startDate: filters.startDate,
    endDate: filters.endDate,
    categoryId: filters.categoryOption && filters.categoryOption.value === null
      ? 'null'
      : filters.categoryOption?.value,
    courseId: filters.programOption?.value,
  }), [filters.categoryOption, filters.endDate, filters.programOption?.value, filters.startDate])

  const hasAppliedFilters = !_.isEqual(filters, DEFAULT_FILTERS)

  const onClearFilters = () => setFilters(DEFAULT_FILTERS)

  const onSubmitFilters = (newFilters) => {
    if (!_.isEqual(filters, newFilters)) {
      setFilters(prevState => ({ ...prevState, ...newFilters }))
    }
  }

  useEffect(() => {
    dispatch(getCommunityCategories())
    dispatch(getProgramsFilterOptions({ completed: true, active: true }))
  }, [dispatch])

  return (
    <div className={classnames('d-flex flex-column', styles.communityLeaderboard)}>
      <div className='p-3 d-flex justify-content-between align-items-center'>
        <h3 className={styles.title}>{t('dashboard.coach.coachDashboardCommunityLeaderboard.title')}</h3>
        <FiltersButtonDropdown
          title={t('dashboard.coach.coachDashboardCommunityLeaderboard.filtersTitle')}
          defaultFilters={DEFAULT_FILTERS}
          appliedFilters={filters}
          onSubmitFilters={onSubmitFilters}
        />
      </div>
      <LeaderboardWrapper
        withDetailedLeaderboard
        withClearFiltersButton={hasAppliedFilters}
        filters={requestFilters}
        onClearFiltersClick={onClearFilters}
        classNames={{
          tabs: 'flex-grow-1',
          tabList: 'mx-3',
        }}
      />
    </div>
  )
}

export default CoachDashboardCommunityLeaderboard
